import '../config';
import $, { event } from "jquery";

async function Api(TypeRequest, params, type_api = 'GET') {
    try {
        const result = await new Promise((resolve, reject) => {
            $.ajax({
                type: type_api,
                cache: true,
                url: `${global.config.domain_url}/rest/${TypeRequest}`,
                data: params,
                headers: {
                    "Accept": "application/json",
                },
                xhrFields: {
                    withCredentials: true // برای ارسال کوکی‌ها
                },
                success(result) {
                    resolve(result); // بازگشت مقدار در صورت موفقیت
                },
                error(err) {
                    reject(err); // مدیریت خطا
                }
            });
        });
        return result; // مقدار نهایی بازگردانده می‌شود
    } catch (error) {
        throw error; // مدیریت خطا در جایی که این تابع استفاده می‌شود
    }
}
async function ApiWebhesab(Function, params) {
   
}
export { Api, ApiWebhesab };
